import { Module } from 'vuex-module-decorators';
import { CondOperator, SFields } from '@dataui/crud-request';
import { JobView } from '@gid/models';
import {
  CrudList,
  CrudListFilters,
} from '@gid/vue-common/store/shared/crud-list.module';

/**
 * Pending product orders hide test jobs by default. Shared by the list view
 * (ProductOrdersPending) and the nav badge (ProductOrdersPendingCount) so the
 * badge count can never silently drift from the list's default. See GID-2236.
 */
export const EXCLUDE_TEST_JOBS_FILTER: SFields = {
  'JobView.testOrder': {
    [CondOperator.EQUALS]: false,
  },
};

export interface FilterArrayOption {
  id: string;
  name: string;
}

export interface ProductOrderPendingFilters extends CrudListFilters {
  search: string;
  opportunity: FilterArrayOption[];
  supplier: FilterArrayOption[];
  partner: FilterArrayOption[];
  product: FilterArrayOption[];
}

export const moduleName = 'productOrdersPending';

@Module({ name: moduleName, namespaced: true })
export default class ProductOrdersPendingModule extends CrudList<JobView> {
  crudEndpoint: string = '/documents-api/product-orders-pending';
  filters: ProductOrderPendingFilters = {
    skipPersist: false,
    search: '',
    opportunity: [],
    supplier: [],
    partner: [],
    product: [],
  };
}
